import React from "react";
import { useGlobalContext } from "../../providers/context";

const UserName = () => {
  const { stateGlobal } = useGlobalContext();

  return (
    <>
      <a className="dropdown-toggle">
        <span className="block m-t-xs font-bold">
          {stateGlobal.usuario.nome}
        </span>
        {/* <span className="text-muted text-xs block">
          Art Director <b className="caret"></b>
        </span> */}
      </a>
    </>
  );
};

export default UserName;
